import { defineMessages } from 'react-intl';

const messages = defineMessages({
  customsHeader: {
    description: 'orderDrawer.customs.header',
    defaultMessage: 'Customs Declarations',
    id: 'TSRh3D',
  },
  sectionAriaLabel: {
    description: 'Aria label for the expandable customs declarations section',
    defaultMessage: 'Customs Declarations expander section',
    id: 'FkeiyN',
  },
  error: {
    description: 'orderDrawer.customs.error',
    defaultMessage: 'Error',
    id: 'oFogXp',
  },
});

export default messages;
